import { gql } from "@apollo/client";

export const GET_PARAMETROS_SOLICITUD_JUSTIFICACION = gql`
query GetParametrosSolicitudPresupuesto($idEvaluacion: Int!) {
    parametrosSolicitudPresupuesto(idEvaluacion: $idEvaluacion) {
        diasCondiContrato
        contratosCO
    }
}`;